export default __webpack_public_path__ + "static/media/discount-icon.83f99084.svg";